import { ReactProperties } from "types";

export const createReactStyleReference = async (): Promise<void> => {
  return new Promise((resolve) => {
    const fragment = document.createDocumentFragment();
    const style = document.createElement("style");
    style.innerHTML = `
      html {
        font-size: 100%;
      }
    `;
    fragment.appendChild(style);
    const { styleSheetURL } = backendData();
    const linkElem = document.createElement("link");
    linkElem.setAttribute("rel", "stylesheet");
    linkElem.setAttribute("href", styleSheetURL);
    fragment.appendChild(linkElem);

    window.reactStyleReference = () => fragment.cloneNode(true);
    return resolve();
  });
};

export const backendData = () => {
  const { styleSheetURL, reactdata } = (document as unknown) as {
    styleSheetURL: string;
    reactdata: ReactProperties;
  };
  return { styleSheetURL, reactdata };
};

export const attachReactShadowRoot = async (
  element: HTMLElement
): Promise<HTMLElement> => {
  return new Promise((resolve) => {
    element.attachShadow({ mode: "open" });
    if (!element.shadowRoot) {
      throw new Error("Failed to attach shadowRoot!");
    }
    const container = document.createElement("div");
    const maxTimeoutResolve = setTimeout(() => {
      resolve(container);
    }, 5000);
    element.shadowRoot.appendChild(container);

    const { styleSheetURL } = backendData();
    const linkElem = document.createElement("link");
    linkElem.setAttribute("rel", "stylesheet");
    linkElem.setAttribute("href", styleSheetURL);
    linkElem.onload = () => {
      if (maxTimeoutResolve) clearTimeout(maxTimeoutResolve);
      resolve(container);
    };
    element.shadowRoot.appendChild(linkElem);
  });
};
